import { render, staticRenderFns } from "./OverlayCloseIcon.vue?vue&type=template&id=5a538a04&"
import script from "./OverlayCloseIcon.vue?vue&type=script&lang=js&"
export * from "./OverlayCloseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports